import { Injectable } from '@angular/core';
import {
  BLOCKLY_EVENT_STRINGS,
  getBlocklyEventStrings,
  getRawBlocklyEventStrings
} from '@shared/blockly/event-strings';

@Injectable({
  providedIn: 'root'
})
export class EventsStringService {
  // Define a type for event entries
  public static readonly alleventsList: [string, string][] = BLOCKLY_EVENT_STRINGS;

  public get(startsWith?: string): [string, string][] {
    return getBlocklyEventStrings(startsWith);
  }

  public getRaw(startsWith?: string): [string, string][] {
    return getRawBlocklyEventStrings(startsWith);
  }
}
